import PlaceholderCard from 'components/ResultsList/PlaceholderCard/PlaceholderCard';
import styles from './Skeleton.module.css';
const Skeleton = () => {
  return <div className={styles.skeletonWrapper} data-sentry-component="Skeleton" data-sentry-source-file="Skeleton.tsx">
      <PlaceholderCard data-sentry-element="PlaceholderCard" data-sentry-source-file="Skeleton.tsx" />
      <PlaceholderCard data-sentry-element="PlaceholderCard" data-sentry-source-file="Skeleton.tsx" />
      <PlaceholderCard data-sentry-element="PlaceholderCard" data-sentry-source-file="Skeleton.tsx" />
      <PlaceholderCard data-sentry-element="PlaceholderCard" data-sentry-source-file="Skeleton.tsx" />
      <PlaceholderCard data-sentry-element="PlaceholderCard" data-sentry-source-file="Skeleton.tsx" />
    </div>;
};
export default Skeleton;